import React, { useRef } from "react";
import classNames from "classnames";

import Column from "./Column";
import styles from "fantastic/components/hoc/styles";
import sectionPadding from "fantastic/lib/sectionPadding";

const Section = ({
  id,
  contents,
  full_width,
  style,
  mobile,
  show,
  css_padding_left,
  css_padding_right,
  css_padding_top,
  css_padding_bottom,
  checkContrast
}) => {
  const table = classNames("fantastic-section", {
    row: full_width,
    container: !full_width,
    'hide-for-desktop': 'mobile' === show,
    'hide-for-small': 'desktop' === show
  });
  const row = classNames({
    row: !full_width,
    container: full_width,
   });

  const columnClasses = ({ column }) => classNames("columns", column);

  const wrapperClasses = ({ meta: { firstChild, lastChild } }) =>
    classNames("wrapper", {
      first: firstChild,
      last: lastChild
    });

  const wrapperPadding = (column) =>
    sectionPadding(column, { css_padding_left, css_padding_right, css_padding_top, css_padding_bottom });

  return (
    <table className={table} style={full_width ? style : {}}>
      <tbody>
        <tr>
          <td>
            <table className={row} style={full_width ? {} : style}>
              <tbody>
                <tr>
                  {contents &&
                    contents.map(column => (
                      <td key={column.id} className={wrapperClasses(column)}>
                        <table className={columnClasses(column)}>
                          <tbody>
                            <tr>
                              <td style={wrapperPadding(column)}>
                                <Column {...column} mobile={mobile} checkContrast={checkContrast}/>
                              </td>
                              <td className="expander" />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    ))}
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default styles("background", "border-section")(Section);
